module.exports = __webpack_public_path__ + "img/logo.987c3e22.png";